import { useAuthenticator } from "@aws-amplify/ui-react";
import { useRouter } from "next/router";
import { useEffect } from "react";
import styled from "styled-components";

// Types
import { LayoutProps, Status } from "../../types";

// State
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchUserAsync,
  selectSignedInUser,
} from "../../app/signedInUserSlice";

// Components
import { Header } from "../Header";
import { LoadingOverlay } from "../LoadingOverlay";
import * as Bootstrap from "../Bootstrap";

export const AuthenticatedLayout = ({ children }: LayoutProps) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectSignedInUser);

  const { authStatus, route } = useAuthenticator(({ authStatus, route }) => [
    authStatus,
    route,
  ]);

  useEffect(() => {
    dispatch(fetchUserAsync(false));
  }, [dispatch]);

  useEffect(() => {
    // User is authenticated, all good, we don't have to do anything
    if (authStatus === "authenticated") {
      return;
    }

    // We don't want to redirect user before we actually check if the user is
    // authenticated authStatus === "configuring" with combination of
    // route === "idle" is the initial state of the authenticator, before it
    // even start checking authentication
    if (authStatus === "configuring" && route === "idle") {
      return;
    }

    const from = Array.isArray(router.query.from)
      ? router.query.from.pop()
      : router.query.from || "/";

    // noinspection JSIgnoredPromiseFromCall
    router.push(`/sign-in?from=${from}`);
  }, [authStatus, route, router]);

  return (
    <LoadingOverlay
      when={user.status === Status.Loading || authStatus !== "authenticated"}
    >
      <Header />
      <Styled.main className="flex-shrink-0 overflow-auto">
        <Bootstrap.Container>
          <Bootstrap.Row>
            <Bootstrap.Col
              as="section"
              xs={12}
              className="ms-sm-auto px-md-4 mb-4"
            >
              {children}
            </Bootstrap.Col>
          </Bootstrap.Row>
        </Bootstrap.Container>
      </Styled.main>
    </LoadingOverlay>
  );
};

const Styled = {
  main: styled.main`
    height: calc(100vh - 69px);
  `,
};
